var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",style:(("background: " + _vm.color))},[_c('v-text-field',{attrs:{"width":"100%","outlined":"","append-icon":"mdi-magnify"},on:{"input":_vm.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }